import {
  FavoriteState,
  LikeState,
  OnboardingCategory,
  PlaybackState,
  ProfileStats,
  PushToken,
  ReminderDate,
  SubscriptionInterval,
  Deal,
} from '../../api/types/others';

export type CustomSubscriptionData = {
  subscriptionId: string;
  subscriptionTransaction?: string;
  subscriptionExpirationDate?: number;
  subscriptionIntervals?: SubscriptionInterval[];
};
export type CustomSpecialTagsData = {
  isAdmin: boolean;
  isTester: boolean;
};
export type CustomUserLifetimeData = {
  createdAt: number;
  updatedAt?: number;
  lastSeenAt?: number;
};
export type CustomFirstAluxExpProgress = {
  aluxExpOpenedLessons?: number;
  aluxExpFinishedLessons?: number;
};

export type PreprocessedProfileFieldDataType =
  | string
  | number
  | PlaybackState
  | OnboardingCategory[]
  | LikeState[]
  | FavoriteState[]
  | PushToken[]
  | ReminderDate[]
  | ProfileStats
  | SubscriptionInterval
  | CustomSubscriptionData
  | CustomSpecialTagsData
  | CustomUserLifetimeData
  | CustomFirstAluxExpProgress
  | Deal;

export const UserProfileFieldTypes = {
  text: 'text',
  list: 'list',
  table: 'table',
  custom: 'custom',
  other: 'other',
} as const;

export type UserProfileFieldType =
  | typeof UserProfileFieldTypes.text
  | typeof UserProfileFieldTypes.list
  | typeof UserProfileFieldTypes.table
  | typeof UserProfileFieldTypes.custom
  | typeof UserProfileFieldTypes.other;

export type PreprocessedProfileField = {
  displayName: string;
  fieldType: UserProfileFieldType;
  data: PreprocessedProfileFieldDataType | PreprocessedProfileFieldDataType[];
  extraData?: string;
};

export type UserProfileFields = {
  readOnly: PreprocessedProfileField[];
  editable: PreprocessedProfileField[];
};
